import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { prefix } from "./constants.js";
import AssignmentUnitsResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
const loadAssignmentUnitsEpicReducerArgs = {
  actionPrefix: `${prefix}/LOADV2`,
  reduxKeyNested: () => ["assignmentUnits"],
  loadResource: (inputPayload) => AssignmentUnitsResource.getAssignmentUnits(inputPayload.workspaceId),
  onCompleteSuccess: (resourceResult) => resourceResult.value
};
const loadAssignmentUnitsEpicReducer = loadResourcesUtils(loadAssignmentUnitsEpicReducerArgs);
export {
  loadAssignmentUnitsEpicReducer
};
//# sourceMappingURL=epicsV2.js.map
